module.exports = __webpack_public_path__ + "img/new.990f1a00.svg";